
<div class="row" *ngIf="isOrderAcceptanceDisabled">
  <div class="col">
    <div class="alert alert-danger"><span>Order Acceptance has been disabled on this project for the following reason: {{ orderAcceptanceDisableReason }}</span></div>
  </div>
</div>